import React from 'react'
import Link from 'gatsby-link'
import { Icon } from 'antd';


class Header extends React.Component {

  constructor() {
    super();
    this.state = {
      open: false
    };
    this.toggleNav = this.toggleNav.bind(this);
    this.closeNav = this.closeNav.bind(this);
  }


  toggleNav() {
    this.setState({ open: ! this.state.open });
  }

  closeNav() {
    this.setState({ open: false });
  }



  render() {

    const showNav = (
      <div className="header--res--nav">
        <Link to="/articles" activeClassName="active" onClick={ this.closeNav }>Articles</Link>
        <Link to="/open-source" activeClassName="active" onClick={ this.closeNav }>Open Source</Link>
        <Link to="/store" activeClassName="active" onClick={ this.closeNav }>Store</Link>
        <Link to="/about-me" activeClassName="active" onClick={ this.closeNav }>About Me</Link>
        <Link to="/contact" activeClassName="active" onClick={ this.closeNav }>Contact</Link>

        <Link to="/archive" activeClassName="active" onClick={ this.closeNav }>Archive</Link>
        <Link to="/newsletter" activeClassName="active" onClick={ this.closeNav }>Newsletter</Link>

      </div>
    );


    return (
      <div className="component--header" >
      <div className="inner">

        <h1>
          <Link to="/">Dhruv Kumar Jha</Link>
        </h1>

        <div className="flex">

          <nav className="primary--nav--new">
            <Link to="/articles" activeClassName="active">Articles</Link>
            <Link to="/open-source" activeClassName="active">Open Source</Link>
            <Link to="/store" activeClassName="active">Store</Link>
            <Link to="/about-me" activeClassName="active">About Me</Link>
            <Link to="/contact" activeClassName="active">Contact</Link>
          </nav>

          <div className="primary--nav--res">
            <Icon type="bars" className={ this.state.open ? 'toggle-icon active' : 'toggle-icon' } onClick={ this.toggleNav } />
            { this.state.open && showNav }
          </div>

        </div>


      </div>
      </div>
    )

  }


}


export default Header



// WEBPACK FOOTER //
// ./src/global/components/Header.js